import { z } from 'zod'

export const ZPartnership = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  link: z.string(),
  image: z.string(),
})

export const ZEvent = z.object({
  id: z.number(),
  title: z.string(),
  landingPageCode: z.string(),
  link: z.string(),
  image: z.string(),
  startAt: z.string(),
  endAt: z.string().nullable(),
})

export enum CampaignType {
  EVENT = 'EVENT',
  PARTNERSHIP = 'PARTNERSHIP',
  ARTICLE = 'ARTICLE',
}

export const ZCampaignDetail = z.object({
  id: z.number(),
  type: z.nativeEnum(CampaignType),
  title: z.string(),
  description: z.string().nullable(),
  landingPageCode: z.string().nullable(),
  link: z.string(),
  image: z.string(),
  categoryId: z.number().nullable(),
  categoryName: z.string().nullable(),
})

export const ZArticle = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  landingPageCode: z.string(),
  link: z.string(),
  image: z.string(),
  categoryId: z.number(),
  categoryName: z.string(),
})

export const ZArticleCategory = z.object({
  id: z.number(),
  name: z.string(),
})

export type TPartnership = z.infer<typeof ZPartnership>
export type TEvent = z.infer<typeof ZEvent>
export type TCampaignDetail = z.infer<typeof ZCampaignDetail>
export type TArticle = z.infer<typeof ZArticle>
export type TArticleCategory = z.infer<typeof ZArticleCategory>

export type TEditorPickArticle = Pick<
  TArticle,
  'id' | 'title' | 'description' | 'landingPageCode' | 'link'
>
